import { render, staticRenderFns } from "./DownloadUpload.vue?vue&type=template&id=01b6c69f&scoped=true&"
import script from "./DownloadUpload.vue?vue&type=script&lang=js&"
export * from "./DownloadUpload.vue?vue&type=script&lang=js&"
import style0 from "./DownloadUpload.vue?vue&type=style&index=0&id=01b6c69f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6c69f",
  null
  
)

export default component.exports